import { Recitation } from "../models/Recitation";

export const RECITATIONS: Recitation[] = [
  {
    name: "Abbad",
    code: "abbad-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/abbad-64/",
    scaling: 0.6
  },
  {
    name: "Abdul Bassit (Mujawwad)",
    code: "abdulbassit-mujawwad-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/abdulbassit-mujawwad-64/",
    scaling: 1.0
  },
  {
    name: "Abdul Bassit (Murattal)",
    code: "abdulbassit-murattal-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/abdulbassit-murattal-64/",
    scaling: 1.0
  },
  {
    name: "Ad-Dussary",
    code: "addussary-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/addussary-64/",
    scaling: 1.0
  },
  {
    name: "Al-Afasy",
    code: "alafasy-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/alafasy-64/",
    scaling: 1.0
  },
  {
    name: "Al-Ajamy",
    code: "alajamy-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/alajamy-64/",
    scaling: 1.0
  },
  {
    name: "Al-Banna",
    code: "albanna-32",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/albanna-32/",
    scaling: 0.8
  },
  {
    name: "Al-Ghamdi",
    code: "alghamdi-40",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/alghamdi-40/",
    scaling: 0.85
  },
  {
    name: "Al-Hudhaify",
    code: "alhudhaify-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/alhudhaify-64/",
    scaling: 0.85
  },
  {
    name: "Al-Hussary",
    code: "alhussary-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/alhussary-64/",
    scaling: 1.0
  },
  {
    name: "Alili",
    code: "alili-128",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/alili-128/",
    scaling: 0.5
  },
  {
    name: "Almuaikali",
    code: "almuaikali-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/almuaikali-64/",
    scaling: 0.7
  },
  {
    name: "Ar-Rifai",
    code: "arrifai-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/arrifai-64/",
    scaling: 1.0
  },
  {
    name: "Ash-Shateri",
    code: "ashsheteri-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/ashsheteri-64/",
    scaling: 1.0
  },
  {
    name: "Ash-Shuraym",
    code: "ashshuraym-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/ashshuraym-64/",
    scaling: 1.0
  },
  {
    name: "As-Sudais",
    code: "assudais-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/assudais-64/",
    scaling: 1.0
  },
  {
    name: "Ayyoub",
    code: "ayyoub-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/ayyoub-64/",
    scaling: 0.7
  },
  {
    name: "Basfar",
    code: "basfar-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/basfar-64/",
    scaling: 1.0
  },
  {
    name: "Jaber",
    code: "jaber-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/jaber-64/",
    scaling: 0.7
  },
  {
    name: "Minshawy",
    code: "minshawy-64",
    seperator: "",
    bismiSingle: false,
    baseUrl: "https://media.quranco.com/audio/minshawy-64/",
    scaling: 1.0
  },
  {
    name: "Salamah",
    code: "salamah-128",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/salamah-128/",
    scaling: 1.0
  },
  {
    name: "Tunaiji",
    code: "tunaiji-64",
    seperator: "",
    bismiSingle: true,
    baseUrl: "https://media.quranco.com/audio/tunaiji-64/",
    scaling: 0.9
  }
];
